import { Collapse, List } from "@mui/material";
import { SideBarItem } from "./SideBarItem";
import { Fragment, useState } from "react";
import { usePathname } from "../../hooks/usePathname";
import { getNavItemState } from "../../utils/common";

export type MenuItem = {
  title: string;
  path?: string;
  children?: MenuItem[];
  newTab?: boolean;
  icon:{
    active: string,
    innactive: string,
  }
};
type ListProps = {
  ItemList: MenuItem[];
  selectedItem?: string;
  onItemClick?: (menuOption: MenuItem, index: number | string) => void;
  onLogoutClick?: () => void;
  onNotificationClick?: () => void;
};

export default function SideBarList({
  ItemList = [],
  onItemClick = () => {}
}: Readonly<ListProps>) {
  const [open, setOpen] = useState<Record<string, boolean>>({});

  const handleClick = (menu: MenuItem, index: number) => {
    if (menu.children) {
      setOpen((prev) => ({ ...prev, [menu.title]: !prev[menu.title] }));
    } else {
      onItemClick(menu, index);
    }
  };

  const path=usePathname();
 
  return (
    <List sx={styles.listContainer}>
      {ItemList.map((menu, index) => {
         const {isMainMenuSelected,isSubMenuSelected}=getNavItemState(menu,path)

         const openMainMenu =
               open.hasOwnProperty(menu.title)
               ? open[menu.title]
               : isSubMenuSelected;
        
        return (
          <Fragment key={`${menu.title}-${index}`}>
            <SideBarItem
              menu={menu}
              selected={isMainMenuSelected}
              onClick={() => {
                handleClick(menu, index);
              }}
              open={openMainMenu}
            />
  
            {menu.children && (
              <Collapse in={openMainMenu} timeout="auto" unmountOnExit>
                <List>
                  {menu.children.map((child, childIndex) => {
                    const {isMainMenuSelected:subMenuTabSelected}=getNavItemState(child,path)         
                    return (
                      <SideBarItem
                        menu={child}
                        key={`${child.title}-${childIndex}`}
                        selected={subMenuTabSelected}
                        onClick={() =>
                          onItemClick(child, `${index}-${childIndex}` as string)
                        }
                        open={open[child.title]}
                        isChild={true}
                      />
                    )
                  }
                  )}
                </List>
              </Collapse>
            )}
          </Fragment>
        )
      })}
    </List>
  );
}

function SideBarFooterList({
  ItemList = [],
  onItemClick = () => {},
  selectedItem,
  onNotificationClick = () => {},
}: Readonly<ListProps>) {
  return (
    <List sx={styles.listContainer}>
      {ItemList.map((menu: MenuItem, index: number) => (
        <SideBarItem
          menu={menu}
          key={`${menu.title}-${index}`}
          selected={selectedItem === `${index}`}
          onClick={() => {
            if (menu.title !== "nottifications") {
              onItemClick(menu, index);
            } else {
              onNotificationClick();
            }
          }}
        />
      ))}
    </List>
  );
}

export { SideBarFooterList };

const styles = {
  listContainer: {
    p: "0px 16px",
  },
};

export { SideBarList };
